export default "__VITE_ASSET__BW3rXmkz__"